import styles from "./styles.module.scss";

function EditedBadge({ languageInfo }) {
  return (
    <div dir="auto" className={styles.reychat_edited_message_subtitle}>
      {languageInfo.texts.edited}
    </div>
  );
}

export default EditedBadge;
